import { render } from "./Noregistre.vue?vue&type=template&id=0839fd98&scoped=true"
const script = {}

import "./Noregistre.vue?vue&type=style&index=0&id=0839fd98&scoped=true&lang=css"

import exportComponent from "/root/apps/cantic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0839fd98"]])

export default __exports__